    
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { ProductKeyQuantity } from 'Api/DynamicwebApi';
import cart from 'Store/cart/cart';
import ABaseComponent from 'Components/Base/ABaseComponent';

const namespace: string = 'cart';

export enum AddToBasketState {
    None    = 0,
    Adding  = 2,
    Added   = 3,
    Error   = 4
}
@Component({
    template: '#add-to-basket-field-template'
})
export default class AddToBasketFieldComponent extends ABaseComponent {
    
    // Properties
    @Prop()
    productId: string;
    @Prop()
    variantId: string;
    @Prop()
    unitOfMeasure: string;
    @Prop({default: "LANG1"})
    languageId: string;
    @Prop()
    extraFields : {[key: string]: any};

    state: AddToBasketState = AddToBasketState.None;
    error: string = '';

    internalQuantity : number = 0; 

    get cart(){
        return cart.state;
    }

    get variantFieldId() : string {
        return this.productId + "_" + this.variantId
    }

    get quantity() : number {
        return this.internalQuantity;
    }
    set quantity(val : number) {
        this.internalQuantity = val;
        this.setLoading();
        this.state = AddToBasketState.Adding;

        cart.dispatchUpdateCart(new ProductKeyQuantity({
            productId: this.productId,
            variantId: this.variantId,
            unitOfMeasure: this.unitOfMeasure,
            extraKeys: this.extraFields,
            quantity: this.quantity,
            languageId: this.languageId
        })).then(() => {
            this.state = AddToBasketState.Added;
            this.setLoaded();
        })
        .catch(e => {
            this.state = AddToBasketState.Error;
            this.setError(e);
        });
    }

    @Watch('unitOfMeasure')
    public unitOfMeasureChanged() {
        this.load();
    }

    mounted() {
        this.load();
    }

    load() {
        this.internalQuantity = 0;
        this.state = AddToBasketState.None;
        this.error = '';
        cart.dispatchFetchCart().then(
            () => {
                if (cart.state.summary && this.state !== AddToBasketState.Adding) {
                    for (let line of cart.state.summary.lines) {
                        if (line.productId !== this.productId) continue;
                        if (line.variantId !== this.variantId) continue;
                        if (line.unitOfMeasure !== this.unitOfMeasure) continue;

                        let differenceInExtraFields = false;
                        for (let key in this.extraFields) {
                            if (line.extraKeys[key] !== this.extraFields[key]) {
                                differenceInExtraFields = true;
                            }
                        }
                        if (differenceInExtraFields) continue;

                        this.internalQuantity = line.quantity;
                        return;
                    }
                }
            }
        );

    }   
}

Vue.component('add-to-basket-field', AddToBasketFieldComponent);
